const GLOBAL_BASE_TEST_ID = 'chat-filter-header-global';
const LOCAL_BASE_TEST_ID = 'chat-filter-header-local';

export const CHAT_FILTER_HEADER_TEST_IDS = {
  container: 'chat-filter-header',
  title: 'chat-filter-header-title',
  global: GLOBAL_BASE_TEST_ID,
  globalGroup: `${GLOBAL_BASE_TEST_ID}-group`,
  globalLabel: `${GLOBAL_BASE_TEST_ID}-label`,
  globalChips: `${GLOBAL_BASE_TEST_ID}-chips`,
  globalToggle: `${GLOBAL_BASE_TEST_ID}-toggle`,
  local: LOCAL_BASE_TEST_ID,
  localGroup: `${LOCAL_BASE_TEST_ID}-group`,
  localLabel: `${LOCAL_BASE_TEST_ID}-label`,
  localChips: `${LOCAL_BASE_TEST_ID}-chips`,
  localToggle: `${LOCAL_BASE_TEST_ID}-toggle`,
};
